export default __webpack_public_path__ + "static/media/CliniMACS_Prodigy_TCT_Transduction_Process_Appsheet.f9bcf0e1.pdf";